export const USER_ROLES = {
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  PARTNER: "partner",
  INTERNAL: "internal",
  EXTERNAL: "external",
  DESIGNER: "designer",
};
